module.exports = __webpack_public_path__ + "static/propagation-eaeb030fd18d9542f5e6e5fc45d72a0b.svg";